const widgetTypes = {
  agentInstalls: 'agentInstalls',
  blog: 'blog',
  community: 'community',
  deviceNotifications: 'deviceNotifications',
  diskEncryption: 'diskEncryption',
  expiredPasswords: 'expiredPasswords',
  fundamentals: 'fundamentals',
  guidedSetup: 'guidedSetup',
  msp: 'msp',
  tutorialResources: 'tutorialResources',
  upcomingPasswordExpiration: 'upcomingPasswordExpiration',
  userLockouts: 'userLockouts',
  newUsers: 'newUsers',
  userNotifications: 'userNotifications',
};

const widgetNames = {
  [widgetTypes.agentInstalls]: 'MacOS Issues',
  [widgetTypes.blog]: 'Blog',
  [widgetTypes.community]: 'Community',
  [widgetTypes.deviceNotifications]: 'Device Notifications',
  [widgetTypes.diskEncryption]: 'Disk Encryption',
  [widgetTypes.expiredPasswords]: 'Expired Passwords',
  [widgetTypes.fundamentals]: 'Fundamentals',
  [widgetTypes.guidedSetup]: 'Guided Setup',
  [widgetTypes.msp]: 'JumpCloud for MSPs',
  [widgetTypes.tutorialResources]: 'Tutorial Resources',
  [widgetTypes.upcomingPasswordExpiration]: 'Upcoming Password Expirations',
  [widgetTypes.userLockouts]: 'User Lockouts',
  [widgetTypes.userNotifications]: 'User Notifications',
};

const itemTypes = {
  device: 'Device',
  user: 'User',
};

const widgetItemTypes = {
  [widgetTypes.agentInstalls]: itemTypes.device,
  [widgetTypes.deviceNotifications]: itemTypes.device,
  [widgetTypes.diskEncryption]: itemTypes.device,
  [widgetTypes.expiredPasswords]: itemTypes.user,
  [widgetTypes.upcomingPasswordExpiration]: itemTypes.user,
  [widgetTypes.userLockouts]: itemTypes.user,
  [widgetTypes.userNotifications]: itemTypes.user,
};

const deviceMetrics = {
  inactiveMetric: 'inactiveMetric',
  withoutUsersMetric: 'withoutUsersMetric',
  withoutPoliciesMetric: 'withoutPoliciesMetric',
  agentOutOfDateMetric: 'agentOutOfDateMetric',
  uptimeMetric: 'uptimeMetric',
};

const userNotificationMetrics = {
  usersWithSambaAccess: 'usersWithSambaAccess',
  usersWithoutPassword: 'usersWithoutPassword',
  userWithAdminSudoPasswordlessAccess: 'userWithAdminSudoPasswordlessAccess',
  usersWithAdminSudoAccess: 'usersWithAdminSudoAccess',
  usersWithoutDevices: 'usersWithoutDevices',
};

const deviceMetricNames = {
  [deviceMetrics.inactiveMetric]: 'Device Inactive Metric',
  [deviceMetrics.withoutUsersMetric]: 'Device Without Users Metric',
  [deviceMetrics.withoutPoliciesMetric]: 'Device Without Policies Metric',
  [deviceMetrics.agentOutOfDateMetric]: 'Device Agent Out Of Date Metric',
  [deviceMetrics.uptimeMetric]: 'Device Uptime Metric',
};

export default {
  riskTypes: {
    low: 'low',
    high: 'high',
  },

  deviceMetrics,
  deviceMetricNames,
  userNotificationMetrics,
  widgetTypes,
  widgetNames,
  widgetItemTypes,
};
